import { useEffect } from 'react';

import { getNotifier } from '@repo/utils';

import { useNavigatorOnLine } from '@/components/online-update/online-update.hooks';

export const OnlineUpdate = () => {
    const isOnline = useNavigatorOnLine();
    const notifier = getNotifier();

    useEffect(() => {
        if (!isOnline) {
            notifier?.add({
                title: 'Offline mode',
                message: 'You are offline',
            });
        }
    }, [isOnline, notifier]);

    return null;
};
